import { createClient } from '@supabase/supabase-js';
import { MODO_DEMO } from './demo/modo';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY!;

/*
 * Na demonstração (`/demo`) o cliente nasce sem memória e sem relógio: não lê
 * a sessão guardada, não a renova e não olha a URL. O app não o usa lá — a
 * sessão é de mentira —, mas um cliente comum, só por existir, renovaria em
 * segundo plano o token de quem já tem conta. A demonstração não fala com o
 * serviço de login, nem por acidente.
 */
export const supabase = MODO_DEMO
  ? createClient(supabaseUrl, supabaseAnon, {
      auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
    })
  : createClient(supabaseUrl, supabaseAnon);
